module.exports = __webpack_public_path__ + "img/pro_two.b27f2846.jpg";